import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiConnectService} from '../../services/api-connect.service';

@Injectable()
export class ExNotificationsService {
  private exNotificationsList: any[];

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService) {
  }

  getExNotifications() {
    return this.http.get(this.apiURL.getExNotifications, {observe: 'response'});
  }

  setExNotificationsList(exNotif) {
    this.exNotificationsList = exNotif;
  }

  getExNotificationsList() {
    if (this.exNotificationsList.length > 0 && this.exNotificationsList !== null) {
      return this.exNotificationsList;
    } else {
      return null;
    }
  }


}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/auth/signin/ex-notifications.service.ts